import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { ProductAttribute, productAttributesType } from '../../types/slices/productAttributesType'

const initialState: productAttributesType =
{
    status: ApiStatus.FETCHED,
    productAttributes: [],
    productAttributeSelected: {} as ProductAttribute,
    errorMessage: undefined,
    action: ''
}

const productAttributeSlice = createSlice({
    name: 'productAttributeSlice',
    initialState,
    reducers: {
        onFetchproductAttribute (state, { payload }: { payload: ProductAttribute[]}) {
        state.status = ApiStatus.FETCHED
        state.productAttributes = payload
        state.errorMessage = undefined
        },
        onSetSelectedproductAttribute (state, { payload }: { payload: ProductAttribute }) {
        state.productAttributeSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
        state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
        state.action = payload
        },
    }
})

export const selectProductAttributeState = (state: RootState) => state.productAttributeSlice
export default productAttributeSlice.reducer
export const {
    onFetchproductAttribute,
    onSetSelectedproductAttribute,
    changeStatus,
    setAction,
} = productAttributeSlice.actions
